export default {
  "h1-title": "Công cụ giao dịch",
  imgUrlLang: "-en",
  "public-btn-text": "Đăng ký ngay",
  screen0: {
    title: "Tạo một thư viện công cụ để đáp ứng nhu cầu giao dịch của bạn",
  },
  screen1: {
    title: "Công cụ chỉ số hiển thị chồng",
    desc: "Công cụ này cho phép nhà đầu tư hiểu rõ sự mạnh mẽ tương đối của các nến trong bất kỳ giai đoạn nào đối với hai loại hàng hóa. Ngoài ra, nó cũng có thể nhận diện tính hiệu phá vỡ có hiệu quả.",
  },
  screen2: {
    title: "Chỉ báo chuyên nghiệp MACD (đường kép)",
    desc: "Công cụ chỉ báo MACD này được sử dụng rộng rãi cho cả cổ phiếu và hợp đồng tương lai. Nó mang lại một số ưu điểm so với MACD đi kèm với MT4, khiến nó phù hợp hơn với sở thích và thói quen của các nhà giao dịch.",
  },
  screen3: {
    title: "Chỉ số thống kê lãi lỗ MTDriver",
    desc: "Công cụ này có thể giúp nhà đầu tư xác định lãi lỗ trong các thời kỳ khác nhau",
  },
  screen4: {
    title: "Thông báo thay đổi giá",
    desc: "Hầu hết các nhà đầu tư có thời gian hạn chế để theo dõi thị trường, và thông báo trên điện thoại di động về thay đổi giá có thể giúp họ nắm bắt xu hướng thị trường mà không phải chịu nhiễu loạn của thị trường.",
  },
  screen5: {
    title: "Đóng EA bằng một click chuột",
    desc: "Nút nhanh được đặt trong giao diện biểu đồ, giúp nhà đầu tư dễ dàng cắt lỗ nhanh chóng và thuận tiện hơn khi thị trường trở nên khó đoán",
  },
  screen6: {
    title: "Tự động khớp lệnh EA",
    desc: "Đặt EA vào trong thư mục MQL4Experts, EA sẽ khớp lệnh vào một thời gian nhất định, cách sử dụng rất đơn giản, người dùng vui lòng tự khám phá.",
  },
  screen7: {
    title: "Giám sát vốn EA",
    desc: "Đặt EA vào trong thư mục MQL4Experts, giám sát vốn EA, đặt tệp âm thanh cảnh báo bạn muốn vào trong thư mục Sounds, sau đó điền tên bài nhạc tương ứng vào ô nhạc của EA.",
  },
  EA交易与指标: "Giao dịch EA và chỉ báo MetaTrader",
  EBC独家精选的MT4:
    "EBC cung cấp bộ công cụ độc quyền gồm các chỉ báo trên MT4 và MT5 cùng với công cụ giao dịch EA để tăng cường độ chính xác trong ra quyết định và hiệu quả vận hành, tối ưu hóa chiến lược, nắm bắt cơ hội thị trường, và đạt lợi thế cạnh tranh.",
  EBCTurbo账户分析系统:
    "EBC Turbo: Phân tích giao dịch bằng các chỉ báo MetaTrader để tối ưu hóa chiến lược",
  实用型技术指标集: "Các chỉ báo thực tiễn: Nắm bắt xu hướng thị trường và chớp lấy cơ hội giao dịch",
  外汇EA策略执行器: "Trình thực thi chiến lược EA Forex phản ứng hiệu quả với những biến động của thị trường và giúp bạn đưa ra quyết định đi trước xu hướng.",
  EBCTurbo账户分析系统2: "Hệ thống phân tích tài khoản EBC Turbo",
  EBC独家盈亏统计和历史回溯工具:
    "Công cụ thống kê lãi lỗ và lịch sử giao dịch độc quyền của EBC, dựa trên hệ thống đánh giá đa chiều và mô hình tích hợp sâu, phân tích toàn diện các chi tiết giao dịch, hỗ trợ tối ưu hóa chiến lược giao dịch.",
  净值收益曲线: "Đường cong lợi nhuận ròng",
  收益率: "Tỉ lệ lợi nhuận",
  最大回撤: "Mức rút tối đa",
  标准差: "Độ lệch chuẩn",
  获利系数: "Hệ số lợi nhuận",
  夏普比率: "Hệ số Sharpe",
  盈利交易: "Giao dịch có lợi nhuận (Tỷ lệ thắng)",
  六维评级图: "Biểu đồ xếp hạng sáu chiều",
  每日: "Thống kê hàng ngày/hàng tháng",
  获取EBCTurbo: "Nhận EBC Turbo",
  实用型技术指标集2: "Bộ chỉ báo kỹ thuật thực dụng",
  经过优化的常用技术指标:
    "Các chỉ báo kỹ thuật thông dụng đã được tối ưu hóa, hỗ trợ phân tích thị trường từ nhiều góc độ và cấu hình tùy chỉnh, giúp người dùng đánh giá chính xác xu hướng thị trường.",
  同图商品叠加工具: "Công cụ chỉ số hiển thị chồng",
  帮助投资者通过叠加两个商品的走势:
    "Giúp nhà giao dịch phân tích sức mạnh của các đường kháng cự thấp giữa hai sản phẩm, xác định các điểm phá vỡ quan trọng, và nâng cao độ chính xác trong quyết định.",
  MACD专业指标: "Chỉ báo chuyên nghiệp MACD (đường kép)",
  提供比普通MACD更为精准的双线指标:
    "Cung cấp chỉ báo kép chính xác hơn so với MACD thông thường, giúp nhà đầu tư nhận biết tốt hơn các tín hiệu mua bán trên thị trường, từ đó nắm bắt cơ hội lợi nhuận tốt hơn.",
  MTDriver盈亏统计指标: "Chỉ số thống kê lãi lỗ MTDriver",
  该指标可协助投资者实时统计不同周期内的盈亏情况:
    "Hỗ trợ nhà đầu tư theo dõi lãi và lỗ theo thời gian thực trên nhiều khung thời gian, cung cấp dữ liệu hữu ích để phát triển chiến lược giao dịch chính xác hơn.",
  价格变动手机推送通知: "Thông báo biến động giá trên điện thoại",
  实时监控市场价格波动:
    "Giám sát biến động giá thị trường theo thời gian thực, với thông báo đẩy ngay lập tức được gửi đến điện thoại của nhà đầu tư khi có biến động lớn, đảm bảo họ có thể phản ứng nhanh chóng tại những thời điểm quan trọng.",
  获取指标: "Nhận chỉ báo",
  外汇EA策略执行器2: "Trình Thực Thi Chiến Lược EA Forex",
  基于高级算法自动执行EA交易策略:
    "Thực thi các chiến lược giao dịch EA bằng thuật toán tiên tiến, thích ứng theo thời gian thực với biến động thị trường để đạt hiệu suất nhanh chóng, an toàn và hiệu quả.",
  定时下单EA软件: "Phần Mềm EA Đặt Lệnh Theo Giờ",
  通过MT4EA:
    "Tự động đặt lệnh vào thời điểm đã được thiết lập trước trên nền tảng MT4 hoặc MT5 mà không cần can thiệp thủ công. Phù hợp với các chiến lược dựa trên thời gian yêu cầu độ chính xác và độ tin cậy cao.",
  EA交易常见问题: "Câu Hỏi Thường Gặp Liên Quan Đến Giao Dịch EA",
  qaList: [
    {
      q: "1. Giao dịch EA là gì và cách thức hoạt động như thế nào?",
      a: ["Giao dịch EA (Expert Advisor) là việc sử dụng các hệ thống tự động trên nền tảng MT4 hoặc MT5 để thực hiện giao dịch. Những hệ thống này tuân theo chiến lược được lập trình sẵn để tự động mua, bán, đặt lệnh dừng lỗ và chốt lời. Chúng giúp cải thiện hiệu quả thực thi, tiết kiệm thời gian theo dõi thị trường và giảm ảnh hưởng của cảm xúc trong quá trình ra quyết định giao dịch."],
    },
    {
      q: "2. Sự khác biệt giữa phần mềm EA trên các nền tảng giao dịch là gì?",
      a: ["EA trên MT4 được viết bằng ngôn ngữ MQL4 và chỉ chạy trên nền tảng MetaTrader 4, trong khi EA trên MT5 sử dụng MQL5 và hoạt động trên nền tảng MetaTrader 5. MT5 hỗ trợ nhiều tính năng hơn và cho phép kiểm tra chiến lược đa luồng. Việc lựa chọn nền tảng phụ thuộc vào yêu cầu giao dịch và khả năng tương thích với EA, vì hai nền tảng này không tương thích với nhau."],
    },
    {
      q: "3. Tôi có thể chạy nhiều chương trình EA trên cùng một nền tảng không?",
      a: ["Có thể, nhưng mỗi EA phải được tải lên một biểu đồ riêng biệt. Bạn có thể chạy nhiều EA trên cùng một nền tảng MetaTrader miễn là chúng được gán cho các biểu đồ khác nhau. Mỗi biểu đồ chỉ có thể chạy một EA, vì vậy cần cẩn trọng để tránh xung đột hoặc quá tải tài nguyên."],
    },
    {
      q: "4. Một EA forex có thể giao dịch nhiều cặp tiền tệ cùng lúc không?",
      a: ["Có thể, tuy nhiên điều này phụ thuộc vào cách EA được thiết kế. Một số EA chỉ tập trung vào một cặp tiền tệ, trong khi các EA khác – đặc biệt là trên MT5 – có thể giao dịch nhiều công cụ tài chính hiệu quả hơn nhờ khả năng xử lý đa luồng của nền tảng."],
    },
    {
      q: "5. Làm sao để chọn được EA forex phù hợp với tôi?",
      a: ["Hãy cân nhắc phong cách giao dịch của bạn (theo xu hướng hay lướt sóng), mức vốn bạn có thể chấp nhận rủi ro và khẩu vị rủi ro cá nhân. Kiểm tra dữ liệu kiểm thử, hiệu suất giao dịch thực tế và liệu EA đó có phù hợp với MT4 hay MT5. Luôn thử nghiệm trên tài khoản demo trước khi áp dụng vào giao dịch thực."],
    },
    {
      q: "6. Giao dịch bằng EA có đảm bảo lợi nhuận không?",
      a: ["Không có công cụ giao dịch nào đảm bảo lợi nhuận. Hiệu suất của EA phụ thuộc vào logic chiến lược, điều kiện thị trường và quản lý rủi ro. EA trên cả MT4 và MT5 chỉ là công cụ hỗ trợ, nhà giao dịch vẫn cần theo dõi hiệu quả và điều chỉnh khi cần thiết."],
    },
  ],
  url:"https://ebcturbo.com/tools?language=en"
};
